import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import LoadingBar from './ui/LoadingBar';
import ListFilter from './filters/ListFilter';
import PaginationButtons from './PaginationButtons';
import _ from 'underscore';

import config from './../config';
import helpers from './../lib/helpers';

function EventsList(props) {
	const [data, setData] = useState(null);
	const [nextUrl, setNextUrl] = useState(null);
	const [previousUrl, setPreviousUrl] = useState(null);
	const [resultCount, setResultCount] = useState(0);
	const [loading, setLoading] = useState(true);

	let history = useHistory();

	useEffect(() => {
		setLoading(true);
		setData(null);

		let urlParams = [];

		if (props.locationId) { // staðsetning
			urlParams.push('location='+props.locationId)
		}

		if (props.groupId) { // staðsetning
			urlParams.push('group='+props.groupId)
		}

		if (props.searchParams) {
			let params = helpers.parseSearchParams(props.searchParams)

			if (params.sida) {
				urlParams.push('limit='+config.pageSize);
				urlParams.push('offset='+(config.pageSize*(params.sida-1)))
			}

			if (params.leit) {
				urlParams.push('search='+params.leit)
			}
		}

		helpers.fetch(config.apiRoot+'/api/events/?'+urlParams.join('&'), (json) => {
			setData(json.results);
			setLoading(false);
			setNextUrl(json.next);
			setPreviousUrl(json.previous);
			setResultCount(json.count);

			if (props.onResponse) {
				props.onResponse(json.results);
			}
		});
	}, [props.locationId, props.groupId, props.searchParams]);

	return (
		<React.Fragment>
			{
				props.enableFilter &&
				<ListFilter filters={[
					{
						label: 'Leit í viðburðum',
						paramName: 'leit',
						type: 'text'
					}
				]}
				currentParams={props.searchParams}
				onFilter={(event) => {
					history.push(history.location.pathname+helpers.updateSearchParams(props.searchParams, event));
				}} />
			}

			{
				props.enableFilter &&
				<div className="tabs-wrapper">
					<ul className="nav nav-tabs">
						<li className="nav-item">
							<Link to={helpers.routerUrls['vidburdir']} className="nav-link active">Listi</Link>
						</li>
						<li className="nav-item">
							<Link to={helpers.routerUrls['vidburdir_timeline']} className="nav-link">Tímalína</Link>
						</li>
					</ul>
				</div>
			}

			<div className={'position-relative '+(props.className || '')+(loading ? ' loading' : '')}>
				<LoadingBar />
				{
					data && data.length > 0 &&
					<React.Fragment>
						{
							props.children
						}
						<table className="table">
							<thead>
								<tr>
									<th>Viðburður</th><th>Dagsetning</th><th>Efnisatriði</th><th>Tegund viðburðar</th>
								</tr>
							</thead>
							<tbody>
								{
									data.map((item, index) => <tr key={index}>
										<td>
											<Link to={helpers.routerUrls['vidburdir_timeline']+item.id}>
												{item.name}
											</Link>
										</td>
										<td>
											{helpers.formatDate(item.date, false, true)}
										</td>
										<td>{item.text}</td>
										<td>{item.event_type ? item.event_type.name : ''}</td>
									</tr>)
								}
							</tbody>
						</table>
						{
							resultCount > config.pageSize &&
							<PaginationButtons resultCount={resultCount}
								previousUrl={previousUrl}
								nextUrl={nextUrl} />
						}
					</React.Fragment>
				}
			</div>
		</React.Fragment>
	)
}

export default EventsList;
